import {
    faFacebook,
    faInstagram,
    faLinkedin,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContactCard from 'components/UI/ContactCard/ContactCard';
import Container from 'components/UI/Container';
import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router';
import TastFooter from './components/TastFooter/TastFooter';
import './index.module.scss';
// =========================

export default function Footer() {
    const history = useHistory();

    return (
        <>
            <div styleName="background">
                <Container>
                    <div styleName="grid">
                        <div styleName="area1">
                            <img
                                styleName="rap-logo"
                                src="images/rap-logos/logo-wit.svg"
                                alt="RAP logo"
                            />
                            <TastFooter />
                        </div>
                        <div styleName="area2">
                            <ContactCard noImage />
                        </div>
                        <div styleName="area3">
                            <h2 styleName="heading">Socials</h2>
                            <div styleName="social-media">
                                <motion.a
                                    href="https://www.linkedin.com/company/grijp-je-kans-in-het-onderwijs/about/?viewAsMember=true"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.03 }}
                                    whileTap={{ scale: 0.79 }}
                                >
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </motion.a>
                                {/* <motion.a
                                    href=""
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.03 }}
                                    whileTap={{ scale: 0.79 }}
                                >
                                    <FontAwesomeIcon icon={faTwitter} />
                                </motion.a> */}
                                <motion.a
                                    href="https://www.facebook.com/grijpjekansinhetonderwijs"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.03 }}
                                    whileTap={{ scale: 0.79 }}
                                >
                                    <FontAwesomeIcon icon={faFacebook} />
                                </motion.a>
                                <motion.a
                                    href="https://www.youtube.com/channel/UCcdAm4pEPQDnyV18t9hhjUQ"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.06 }}
                                    whileTap={{ scale: 1 }}
                                    initial={{ scale: 1.03 }}
                                >
                                    <FontAwesomeIcon icon={faYoutube} />
                                </motion.a>
                                <motion.a
                                    href="https://www.instagram.com/grijpjekansinhetonderwijs/"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.06 }}
                                    whileTap={{ scale: 1 }}
                                    initial={{ scale: 1.03 }}
                                >
                                    <FontAwesomeIcon icon={faInstagram} />
                                </motion.a>
                            </div>
                            {/* <Button
                                color="white"
                                onClick={() => {
                                    setNewsModalIsOpen(true);
                                }}
                            >
                                Nieuwsbrief
                                <FontAwesomeIcon icon={faMailchimp} />
                            </Button> */}
                        </div>
                        <div styleName="area4">
                            <h2 styleName="heading">Info</h2>
                            <div styleName="bottom">
                                <a
                                    onClick={() => {
                                        history.push('/over-ons');
                                    }}
                                >
                                    Over ons
                                </a>
                                <a
                                    onClick={() => {
                                        history.push('/onze-scholen');
                                    }}
                                >
                                    Onze scholen
                                </a>
                                <a
                                    onClick={() => {
                                        history.push('/contact');
                                    }}
                                >
                                    Contact
                                </a>
                                {/* <a>Sitemap</a>
                                <a>Disclaimer</a>
                                <a>Privacy statement</a> */}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}
